module.exports = __webpack_public_path__ + "static/img/CFD.9231e7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CFD.png
// module id = YIlj
// module chunks = 128